import { environment } from '@environments/environment';

export const DOWNLOAD_PROMPT_SHOW_PERIOD: number = 14 * (24 * 60 * 60 * 1000); // 14 days

export const enum URL_DOWNLOAD_APP {
  ANDROID = 'https://play.google.com/store/apps/details?id=com.pyjam.dev',
  IOS = 'https://apps.apple.com/us/app/pyjam-content-creation/id6443738033'
}

export const MAX_FILES_COUNT: number = 10; // the backend is set to 15.
export const UPLOAD_STALL_TIMEOUT_MS: number = 3 * 60 * 1000;
export const UPLOAD_FINALIZE_TIMEOUT_MS: number = 5 * 60 * 1000;

export enum MAX_FILE_SIZE {
  MIN = 4,
  SMALL = 10,
  MEDIUM = 500,
  LARGE = 500,
  BIGGEST = 1_500,
}

export function calculateSizeBytes(maxSize: MAX_FILE_SIZE): number {
  return maxSize * 1024 * 1024;
}

export enum MAIL_TYPE {
  SUPPORT = 1,
  USER_REMOVAL = 2,
}

export enum NOTIFICATION_TYPE {
  MESSAGE = 1,
  COMMENT = 2,
  REPLY = 3,
  OFFER = 4,
  STATUS = 5,
  EXTRA_WORK = 6,
  TASK = 7,
  CHAT = 8,
  PAYMENT_SUCCEEDED = 9,
  ONBOARDING = 10,
  INACTIVITY_EXTRA_WORK = 11,
  INACTIVITY_DEADLINE = 12,
  INACTIVITY_OWNER = 13,
  DISPUTED = 14,
  OFFER_STATUS_ACCEPTED = 15,
  OFFER_STATUS_REJECTED = 16,
  DEADLINE = 17,
  EXTRA_WORK_REJECTED = 18,
  EXTRA_WORK_OFFER_EXTRA_PAY = 19,
  EXTRA_WORK_OWNER_APPROVE = 20,
  EXTRA_WORK_PAID = 21,
  EXTRA_WORK_WORKER_APPROVE = 22,
  EXTRA_WORK_PENDING = 23,
  EXTRA_WORK_WORKER_ADDED_RESULTS = 24,
  REPLY_DATA_UPDATED = 25,
  EXTRA_WORK_WAIT_PAY = 26,
  DISPUTE_CANCELED = 27,
  EXTRA_WORK_DELETED = 28,
  EXTRA_WORK_OWNER_APPROVE_RESULTS = 29,
  OFFER_CREATE_TASK = 30,
  PAYMENT_FAILED = 31,
  PAYMENT_CANCELED = 32,
  PAYMENT_AFTER_5_DAYS = 33,
  DISPUTED_TASK_FOR_TRUSTED_USER = 34,
  PAY_FOR_TRUSTED_USER = 35,
  PAYMENT_SUCCEEDED_REPLY_TIPS = 36,
  PAYMENT_SUCCEEDED_AVATAR_ORDER_TIPS = 37,
  BLACKLIST = 38,
  AVATAR_ORDER = 39,
  ACCOUNT_PAYPAL_INVALID = 40,
  AVATAR_ORDER_CANCELLED = 41,
  AVATAR_ORDER_ACCEPTED = 42,
  AVATAR_ORDER_REJECTED = 43,
  AVATAR_ORDER_DONE = 44,
  TASK_UNPUBLISHED = 45,
  TASK_WILL_BE_UNPUBLISHED_AFTER_5_DAYS = 46,
  UPDATE_FRONT = 47,
  SUBSCRIPTION_MESSAGE = 48,
  USER_ACTIONS_LIKE = 49,
  NEW_SUBSCRIBER = 50,
  NEW_CONTENT_COMMENT = 51,
  COMMENT_ANSWER = 52,
  NEW_CONTENT_COMMENT_ANSWER = 53,
  CALL = 54,
  CALL_CANCELLED = 55,
  UNIVERSAL = 999,
}

const CONSTRAINTS = {
  audio: {
    // sampleRate: {ideal: 44100},
    sampleRate: {min: 44100, ideal: 48000, max: 96000},
    sampleSize: {ideal: 16, max: 24},
    channelCount: {exact: 1},
    echoCancellation: false,
    noiseSuppression: false,
    autoGainControl: true,
    latency: 0,
    // @ts-ignore
    googEchoCancellation: false,
    // @ts-ignore
    googAutoGainControl: true,
    // @ts-ignore
    googNoiseSuppression: false,
    // @ts-ignore
    googHighpassFilter: false,
    // @ts-ignore
    googTypingNoiseDetection: false
  },
  video: {
    width: {min: 240, ideal: 1920, max: 1920},
    facingMode: {ideal: 'environment'},
  }
};

const CONSTRAINTS_DEV = {
  audio: true,
  video: {
    width: {ideal: 640},
    facingMode: {ideal: 'environment'},
  }
};

export function getAudioConstraints() {
  return {audio: {sampleRate: {ideal: 48000}, echoCancellation: true, noiseSuppression: true}, video: false};
}

export function getVideoConstraints() {
  return environment.highMediaQuality ? CONSTRAINTS : CONSTRAINTS_DEV;
}

export enum CONTENT_MODE {
  FILES = 'files',
  STREAMS = 'streams',
  RATING = 'rating'
}

export enum CONTENT_TYPE {
  VIDEO = 'video',
  FILE = 'file',
}

export enum REACTION {
  LIKE = 'like',
  DISLIKE = 'dislike',
}

export const TASK_COUNT_ON_PAGE: number = 50;
export const PEOPLE_COUNT_ON_PAGE: number = 50;
export const STREAM_COUNT_ON_PREVIEW_PAGE: number = 10;
export const STREAM_COUNT_ON_PROFILE_PAGE: number = 12;
export const FILE_COUNT_ON_PROFILE_PAGE: number = 12;
export const PROFILE_FILES_PAGES_FOR_PLAYLIST: number = 3;
export const PROFILE_STREAMS_PAGES_FOR_PLAYLIST: number = 3;
export const CHAT_COUNT_ON_PAGE: number = 20;
export const CHAT_MESSAGE_COUNT_ON_PAGE: number = 50;
export const CHAT_MESSAGE_MAX_LENGTH: number = 4096;
export const NOTIFICATION_COUNT_ON_PAGE: number = 20;
export const DIRECT_USER_ROUTE_SEGMENT = 'user';

export enum OPEN_MODE {
  MODAL = 'modal',
  PAGE = 'page',
}
